/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 

document.addEventListener("DOMContentLoaded", function(event) {
    activarMegaMenu();
    activarSubMenus();
});

function activarMegaMenu(){
    $triggers = document.querySelectorAll('.triggerMegaMenu');
    for (let $i = 0; $i < $triggers.length; $i++) {
        const $trigger = $triggers[$i];
        $trigger.addEventListener('click', function(){
            showHideMegaMenu();
        })
        
    }
}

function showHideMegaMenu(){
    document.querySelector('body').classList.toggle('show-menu');
}



function activarSubMenus(){
    $triggers = document.querySelectorAll('.bloque-mega-menu .group-items.has-children, .bloque-mega-menu .facultad.has-children');
    for (let $i = 0; $i < $triggers.length; $i++) {
        const $trigger = $triggers[$i];
        $trigger.addEventListener('click', function(){
            showHideSubMenu(this);
        });
        
    }

}

function showHideSubMenu(element){
    
    // todo: 
    // només per la versió 1 columna
    var w = window.innerWidth;
    if(w < 981){
        if(!element.classList.contains('opened')){
            if(element.classList.contains('facultad')){
                $bloque = element.closest('.bloque-mega-menu');
                $openItems = $bloque.querySelectorAll('.has-children.opened');
                for (let $i = 0; $i < $openItems.length; $i++) {
                    const $item = $openItems[$i];
                    $item.classList.remove('opened');
                }
                element.classList.add('opened');        
            }else{
                // $bloque = element.closest('.bloque-mega-menu');
                $bloque = element.closest('.menu-wrap');
                $openItems = $bloque.querySelectorAll('.has-children.opened');
                for (let $i = 0; $i < $openItems.length; $i++) {
                    const $item = $openItems[$i];
                    $item.classList.remove('opened');
                }
                element.classList.add('opened');    
    
            }
    
            setTimeout(function() {
                scrollToElement(element)
            }, 10);
        
        }else{
            element.classList.remove('opened');
        }

    }

}

function scrollToElement($element){
    $element.closest('.wp-block-columns').scrollTo({top:0, left:0, behavior: "smooth"});
    var rect = $element.getBoundingClientRect();
    // console.log(rect.top, rect.right, rect.bottom, rect.left);
    $currentScroll = $element.closest('.wp-block-columns').scrollTop - 120;

    $element.closest('.wp-block-columns').scrollTo({top:(rect.top + $currentScroll), left:0, behavior: "smooth"});
    // $element.closest('.wp-block-columns').scrollTo({top:(rect.top + $currentScroll), left:0, behavior: "auto"});
}

